import React, { useState } from 'react'
import Layout from '../../components/common/pageLayout'
import constant from '../../constant'
import { Link, useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import List from '../../components/NCR/List/index'
import { v3_ncr } from '../../actions/v3/ncr'
import Filter from '../../components/NCR/List/filter'
import ExportColumnModal from '../../components/common/ExportColumnModal';
import { appendDateRangeToFileName, exportRowsToExcel, getSessionStorage, setSessionStorage } from '../../utils';

const ncrExportColumns = [
    { key: 'ncrId', label: 'NCR ID', value: (item) => item.ID },
    { key: 'subject', label: 'Subject', value: (item) => item.SUBJECT },
    { key: 'description', label: 'Description', value: (item) => item.DESCRIPTION },
    { key: 'projectId', label: 'Project ID', value: (item) => item.PROJECT_ID },
    { key: 'shipId', label: 'Ship ID', value: (item) => item.SHIP_ID },
    { key: 'categoryId', label: 'Category ID', value: (item) => item.CATEGORY_ID },
    { key: 'channelId', label: 'Channel ID', value: (item) => item.CHANNEL_ID },
    { key: 'status', label: 'Status', value: (item) => item.STATUS },
    { key: 'statusComment', label: 'Status Comment', value: (item) => item.STATUS_COMMENT || '' },
    { key: 'createdBy', label: 'Created By', value: (item) => item.CREATED_BY_NAME },
    { key: 'createdOn', label: 'Created On', value: (item) => item.CREATED_ON },
    { key: 'modifiedOn', label: 'Modified On', value: (item) => item.MODIFIED_ON },
];

const getStoredSessionValue = (key, fallback) => {
    if (!key) return fallback;
    try {
        const storedValue = getSessionStorage(key);
        return storedValue ?? fallback;
    } catch (error) {
        return fallback;
    }
};

const NCRList = () => {
    const location = useLocation();
    const history = useHistory();

    const { shipId, projectId, shipName } = location.state;
    const filterStorageKey = shipId ? `iship:ncr:ship:${shipId}:filters` : '';
    console.log(projectId)

    const isPop = history.action === 'POP';

    const [statusCount, setStatusCount] = useState(null)
    const [filterPayload, setFilterPayload] = useState(() => {
        if (isPop) {
            return getStoredSessionValue(filterStorageKey, {});
        } else {
            if (filterStorageKey) setSessionStorage(filterStorageKey, {});
            return {};
        }
    });
    const [data, setData] = useState(null)


    const onChangeFilter = (filterModel) => {
        setFilterPayload(filterModel)
        if (filterStorageKey) {
            setSessionStorage(filterStorageKey, filterModel);
        }
    }

    const encodeFilterPayload = (payload) => {
        try {
            const json = JSON.stringify(payload);
            if (!json) return '';

            if (typeof TextEncoder !== 'undefined') {
                const bytes = new TextEncoder().encode(json);
                let binary = '';
                bytes.forEach((b) => {
                    binary += String.fromCharCode(b);
                });
                return btoa(binary);
            }

            // Fallback for older browsers.
            return btoa(unescape(encodeURIComponent(json)));
        } catch (error) {
            console.error('Failed to encode filter payload:', error);
            return '';
        }
    };

    const fetchAllNCRForExport = async () => {
        const pageSize = 200;
        let page = 1;
        let allRows = [];
        let expectedTotal = 0;
        const encodedFilterPayload = encodeFilterPayload(filterPayload);

        while (true) {
            // eslint-disable-next-line no-await-in-loop
            const res = await v3_ncr(page, pageSize, shipId, encodedFilterPayload);
            if (!res?.status) {
                throw new Error(res?.error || 'Failed to fetch NCR data for export');
            }

            const pageRows = res.result?.ncr || [];
            expectedTotal = Number(res.result?.total || expectedTotal || 0);
            allRows = [...allRows, ...pageRows];

            if (pageRows.length === 0) break;
            if (expectedTotal > 0 && allRows.length >= expectedTotal) break;

            page += 1;
        }

        return allRows;
    };

    const exportExcel = async (selectedColumns = ncrExportColumns) => {
        let exportRows = data?.ncr || [];
        const expectedTotal = Number(data?.total || 0);

        if (!exportRows.length || (expectedTotal > 0 && exportRows.length < expectedTotal)) {
            try {
                exportRows = await fetchAllNCRForExport();
            } catch (error) {
                console.error('Failed to export NCR records:', error);
                alert('Failed to export NCR data');
                return;
            }
        }

        if (!exportRows.length) {
            alert("No NCR data to export");
            return;
        }

        exportRowsToExcel({
            rows: exportRows,
            columns: selectedColumns,
            sheetName: "NCR",
            fileName: `${appendDateRangeToFileName('ncr-data', filterPayload)}.xlsx`,
        });
    }
    return (
        <Layout title={`NCR | ${shipName}`}>
            <div className=" d-flex justify-content-between align-items-center mb-1">
                <h4 className="card-title mb-0"></h4>
                <div>

                    <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#ncr-export-columns-modal"
                        className="btn btn-sm btn-primary me-2"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                    >
                        <i className="mdi mdi-file-excel-outline label-icon" /> Export
                    </button>
                    <Link
                        to={{
                            pathname: constant.Authedcomponent.ncrCreate.url,
                            state: {
                                shipId,
                                projectId,
                                shipName
                            }
                        }}
                        className="btn btn-sm btn-primary me-2"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                    >
                        <i className="fa fa-plus-circle label-icon" /> Create NCR
                    </Link>

                </div>
            </div>

            <Filter
                onChangeFilter={onChangeFilter}
                statusCount={statusCount}
                initialFilter={filterPayload}
            />
            <List
                setStatusCount={setStatusCount}
                filterPayload={filterPayload}
                shipId={shipId}
                data={data}
                setData={setData}
            />
            <ExportColumnModal
                modalId="ncr-export-columns-modal"
                title="Select NCR Columns"
                columns={ncrExportColumns}
                onExport={exportExcel}
            />

        </Layout>

    )
}

export default NCRList
